define('LNRS/Track/TrackVideos',[
    "jquery",
    "eventManager",
    "youtube",
    "Track/DataLayerManager",
    "Track/Events"
], function ($, eventManager, YT, dlmanager, events) {

    var startedVideos = '';

    var states = {
        unstarted: -1,
        ended: 0,
        playing: 1,
        paused: 2,
        buffering: 3,
        cued: 5
    };

    function triggerMilestoneEvent(dlmanager, title, dur, milestone) {
        var o = { site_events: {} };
        o.site_events["video_" + milestone + "_percent"] = "true";
        o["event_name"] = "video playback";
        o["video_name"] = title;
        o["video_duration"] = String(dur);
        o["content_type"] = "video";
        dlmanager.trackAnalytics(o);
    }

    function triggerEvent(dlmanager, videoComponent, player) {
        YT.ready(function () {
            var state = player.getPlayerState(),
                o = { site_events: {} },
                title = player.getVideoData().title,
                dur = player.getDuration();

            player.timeouts = player.timeouts || [];
            o["event_name"] = "video playback";
            o["video_name"] = title;
            o["video_duration"] = String(dur);
            o["content_type"] = "video";

            if (state === states.playing) {

                if (!startedVideos.includes('/' + title + '/')) {
                    o.site_events["video_start"] = "true";
                    dlmanager.trackAnalytics(o);
                    startedVideos = startedVideos + '/' + title + '/';
                }

                var milestones = [25, 50, 75, 95], currentTime = player.getCurrentTime();

                milestones.forEach(function (milestone) {
                    var offset = dur * milestone / 100, milestoneHandler;
                    if (offset < currentTime) {
                        return;
                    }

                    milestoneHandler = triggerMilestoneEvent.bind(null, dlmanager, title, dur, milestone);
                    player.timeouts.push(window.setTimeout(milestoneHandler, (offset - currentTime) * 1000));
                });
            }
            else if (state === states.ended || state === states.paused || state === states.buffering) {
                player.timeouts.forEach(function (timeout) {
                    window.clearTimeout(timeout);
                });

                if (state === 0) {
                    o.site_events["video_complete"] = "true";
                    dlmanager.trackAnalytics(o);
                }
            }
        });
    }

    return function trackVideos() {
        // Tracks Score's Youtube Video components and our custom Video Modal
        $(".score-youtube-video, .video-modal-button").each(function attachScoreVideoListener() {
            var videoComponent = $(this).data("ccf_module");
            if (videoComponent) {
                videoComponent.addStateChangeMessage(events.global.videoStateChange);
            }
        });

        eventManager.subscribe(events.global.videoStateChange, triggerEvent.bind(null, dlmanager));
    };
});
